import { jsx } from 'react/jsx-runtime';
import { ErrorBoundary } from 'react-error-boundary';
import { useClientBootstrapInit, StatsigProvider as StatsigProvider$1, useStatsigClient } from '@statsig/react-bindings';
import { useRef } from 'react';

/**
 * Default error handler that can be overridden via SwitchrProvider props
 * @param err
 */
var errorHandler = function errorHandler(err) {
  var msg = "FAE-894 graceful degradation of Statsig";
  if (typeof window !== 'undefined' && window.NREUM) {
    var _window$NREUM;
    (_window$NREUM = window.NREUM) == null || _window$NREUM.addPageAction == null || _window$NREUM.addPageAction(msg, {
      message: err.message,
      stack: err.stack
    });
  } else {
    // eslint-disable-next-line no-console
    console.warn(JSON.stringify({
      msg: msg,
      err: err,
      message: err.message,
      stack: err.stack
    }));
  }
};
var nullRender = function nullRender() {
  return null;
};

var StatsigProvider = function StatsigProvider(_ref) {
  var children = _ref.children,
    _ref$config = _ref.config,
    key = _ref$config.key,
    options = _ref$config.options,
    serverData = _ref.serverData,
    user = _ref.user,
    onError = _ref.onError;
  var previousDataRef = useRef(serverData);
  var client = useClientBootstrapInit(key, user, serverData, options);
  var context = client.getContext();
  // if for some reason config.disableLogging is set to true and disableLogging is not set then disable logging
  if (options != null && options.disableLogging && !context.options.disableLogging) {
    client.updateRuntimeOptions({
      disableLogging: true
    });
  }
  // update the user when the data changes
  // we need to do this because we include data about the page and page type in the user
  if (previousDataRef.current !== serverData && client != null && client.dataAdapter) {
    try {
      client.dataAdapter.setData(serverData);
      previousDataRef.current = serverData;
      client.updateUserSync(user);
    } catch (err) {
      onError(err);
    }
  }
  return jsx(StatsigProvider$1, {
    client: client,
    children: children
  });
};

var SwitchrProvider = function SwitchrProvider(_ref) {
  var children = _ref.children,
    config = _ref.config,
    serverData = _ref.serverData,
    user = _ref.user,
    _ref$fallbackComponen = _ref.fallbackComponent,
    fallbackComponent = _ref$fallbackComponen === void 0 ? nullRender : _ref$fallbackComponen,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? errorHandler : _ref$onError;
  return jsx(ErrorBoundary, {
    onError: onError,
    FallbackComponent: fallbackComponent,
    children: jsx(StatsigProvider, {
      config: config,
      serverData: serverData,
      user: user,
      onError: onError,
      children: children
    })
  });
};
var useSwitchr = function useSwitchr() {
  var _useStatsigClient = useStatsigClient(),
    checkGate = _useStatsigClient.checkGate,
    getDynamicConfig = _useStatsigClient.getDynamicConfig,
    getExperiment = _useStatsigClient.getExperiment;
  return {
    checkGate: checkGate,
    // client
    getDynamicConfig: getDynamicConfig,
    getExperiment: getExperiment
    // getFeatureGate,
    // getLayer
    // getParameterStore
    // logEvent
  };
};

export { SwitchrProvider, useSwitchr };
//# sourceMappingURL=index.js.map
